module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('datepicker', {
    attrs: {
      "value": _vm.value,
      "format": _vm.customFormatter
    },
    on: {
      "selected": function($event) {
        _vm.updatedDate($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64dce6a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/widgets/gl-datepicker.vue
// module id = 554
// module chunks = 1